import React, { Component } from 'react'
import WarningHolder from '~/Common-Objects/UI/Cards/WarningHolder'


export default class ComponentExplainer extends Component {
    constructor(props) {
        super(props)

        this.state = {
        }
    }

    componentDidMount() {

    }
    componentWillUnmount() {

    }


    render() {


        var style = {};
        if (this.props.elementData.optionFullWidth) style = { flex: "100%" }

        return <div className="dd_toolHolder" style={style}>
            <div className="dd_inputTool">
                <WarningHolder>{this.props.value}</WarningHolder>
            </div>
        </div>


    }
}


